import { useCallback, useEffect, useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { api } from './lib/api';
import { StoreProvider } from './lib/store';
import { AppShell } from './components/AppShell';
import { Login } from './components/Login';
import { Spinner } from './components/ui';
import { Dashboard } from './pages/Dashboard';
import { Timesheet } from './pages/Timesheet';
import { Projects } from './pages/Projects';
import { ShareLinks } from './pages/ShareLinks';
import { SettingsPage } from './pages/Settings';
import { PublicView } from './pages/PublicView';

/** Share links are public by design and must never hit the auth gate. */
function Private() {
  const [signedIn, setSignedIn] = useState<boolean | null>(null);

  const check = useCallback(() => {
    api
      .me()
      .then((r) => setSignedIn(r.signedIn))
      .catch(() => setSignedIn(false));
  }, []);

  useEffect(check, [check]);

  if (signedIn === null) return <Spinner label="Starting" />;
  if (!signedIn) return <Login onSignedIn={check} />;

  return (
    <StoreProvider onSignOut={() => setSignedIn(false)}>
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<Dashboard />} />
          <Route path="timesheet" element={<Timesheet />} />
          <Route path="projects" element={<Projects />} />
          <Route path="share" element={<ShareLinks />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </StoreProvider>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/s/:token" element={<PublicView />} />
        <Route path="/*" element={<Private />} />
      </Routes>
    </BrowserRouter>
  );
}
